import { useContext } from 'react';
import './Intro.css';
import { MapContext } from '../../../context/MapContext';

export default function Intro() {
	const { setMode } = useContext(MapContext);

	return (
		<div className="rightIntro">
			<div className="reportIntrod">
				<div className="logo">
					<img className="logoImg" src="img/KRIHS_logo.png" alt="KRIHS logo" />
					<span className="KRIHSLogo">KRIHS 인터랙티브 리포트</span>
					<span className="subLogo">1인가구 집적지</span>
				</div>

				<div className="introdGroup">
					<div className="TextCont">
						<h1>
							<span className="blueText">[</span> 우리 지역 '1인가구'는 어디에
							많이 있을까? <span className="blueText">]</span>
						</h1>
						<h2>맞춤형 정책수립을 위한 1인가구 분포와 입지 속성 분석</h2>
						<p>
							최근 우리나라 1인가구는 전체 가구 유형 중 가장 큰 비중(34.5%)을
							차지하게 되었습니다(통계청, 2023.12.12. 보도자료).
							<br />
							관련하여 지자체에서는 맞춤형 정책을 위해 '1인가구 전담 기구'를
							설립하는 등 다양한 노력을 기울이고 있습니다.
							<br />
							<br />
							이러한 맥락에서 이번 인터랙티브 리포트는 전국의 1인가구를 1km x
							1km 격자 단위로 분석하여,
							<br />
							공간 분포와 집적지를 분석할 수 있도록 기획하였습니다. 특히,
							1인가구 집적지(격자)의 입지 속성*을 사용자가 직접 분석할 수
							있습니다.
							<br />
							<span className="smFont">
								* 행정복지센터, 대학교, 산업단지, 병·의원(종합병원 포함),
								경찰서(지구대, 파출소 포함)와의 거리
							</span>
							<br />
							<br />
							1인가구의 공간적 분포와 집적지 특성을 세밀하게 파악하면 적재적소의
							맞춤형 정책 수립이 가능할 것입니다.
							<br />
							<span className="smFont">
								※ 참고 : 데이터의 기준 시점은 인터랙티브 리포트 조회 시점의 실제
								현황과 다를 수 있습니다.
							</span>
						</p>
					</div>
					<div className="ImgCont">
						<img
							className="illustImage"
							src="img/introdRightImg.png"
							alt="우리 지역 1인가구는 어디에 많이 있을까? 일러스트 이미지"
						/>
					</div>
				</div>

				<div className="introdGroup second">
					<div className="ImgCont">
						<img
							className="illustImage"
							src="img/introdLeftImg.png"
							alt="1인가구 집적지 분석 조건 설정 일러스트 이미지"
						/>
					</div>
					<div className="TextCont">
						<h1>
							<span className="greenText">[</span> 1인가구 집적지 분석{' '}
							<span className="greenText">]</span>
						</h1>
						<h2 className="greenText">
							관심 지역과 조건을 선택하여{' '}
							<span className="redText">
								여러분이 보고 싶은 1인가구 집적지를 분석해보세요.
							</span>
						</h2>

						<h3>Step 1. 집적지 분석</h3>
						<ul className="analylist">
							<li>
								<span className="label">분석 목적</span>
								<p>
									관심 지역을 대상으로 격자 당 '1인가구 수'의 범위를 설정하여
									'1인가구 집적지'를 확인할 수 있습니다.
								</p>
							</li>
							<li>
								<span className="label">분석 방법</span>
								<p>
									대상지역 선택 &gt; 격자 당 1인가구 수 설정 &gt; 분석수행 클릭!
								</p>
							</li>
							<li className="ex">
								<p>
									<b>[예시]</b> 대상지역 선택{' '}
									<span className="greenText">(00도, 00시)</span> &gt; 격자 당
									1인가구 수 설정 <span className="greenText">(300~최대)</span>{' '}
									&gt;
									<span className="greenText"> 분석수행 클릭!</span>
									<br />
									<b>[해석]</b>{' '}
									<span className="greenText">
										'00도 00시'의 1인가구 수가 '300가구 이상'
									</span>
									인 격자(단위 : 1km × 1km)의 <span className="blueText"></span>
									'위치를 확인'
								</p>
							</li>
						</ul>
						<h3>Step 2. 입지속성 분석</h3>
						<ul className="analylist">
							<li>
								<span className="label">분석 목적</span>
								<p>
									Step 1을 통해 추출한 1인가구 집적지의 '입지속성'을 분석할 수
									있습니다.
								</p>
							</li>
							<li>
								<span className="label">분석 방법</span>
								<p>
									시설명 선택 &gt; 거리 선택 &gt; 기준 선택 &gt; 분석수행 클릭!
								</p>
							</li>
							<li className="ex">
								<p>
									<b>[예시]</b> 시설명 선택{' '}
									<span className="greenText">(산업단지)</span> &gt; 거리 선택{' '}
									<span className="greenText">(750m)</span> &gt; 기준 선택{' '}
									<span className="greenText">(이내)</span> &gt;{' '}
									<span className="greenText"> 분석수행 클릭!</span>
									<br />
									<b>[해석]</b> 1인가구 집적지 중
									<span className="greenText"> '산업단지가 750m 이내'</span>에
									위치한 격자를 확인
								</p>
							</li>
						</ul>
						<button onClick={() => setMode('agglomerate')}>
							Step 1. 집적지 분석 바로가기
							<img src="img/searchIcon.png" alt="바로가기" />
						</button>
					</div>
				</div>
				<div className="line"></div>
				<div className="introdGroup footer">
					<div className="content">
						<p>
							* 기획분석 : 국토연구원 국토모니터링연구센터 안현
							연구원(silentwd3@gmail.com), 이영민 부연구위원(ymlee@krihs.re.kr),
							변필성 선임연구위원 (drbyun@krihs.re.kr)
						</p>
						<p>* 개발총괄 : 국토연구원 황명화 국토모니터링연구센터장(mhhwang@krihs.re.kr)</p>
						<p>* 기술지원 : (주)망고시스템 서세원 연구원(seosewon11@gmail.com)</p>
						<p>* 작성연월: 2024년 1월</p>
					</div>
				</div>
			</div>
		</div>
	);
}
